import React from "react";

export const ClearIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="31" fillRule="nonzero" fill="#3F4447">
                <g transform="translate(19.000000, 16.000000)">
                    <path d="M27.2363838,0.753525891 C28.7612967,0.980754523 28.9924112,3.08452709 27.5531966,3.63738649 C20.8852527,6.19880808 16.3834596,12.6713461 16.3834596,20 C16.3834596,29.6679918 24.1452567,37.5 33.7131314,37.5 C36.046005,37.5 38.3120103,37.0351132 40.4146203,36.1438962 C41.8364563,35.5412337 43.1313294,37.2212228 42.1864693,38.4427216 C37.7986782,44.1151816 31.0768636,47.5 23.8027778,47.5 C10.9299703,47.5 0.5,36.975683 0.5,24 C0.5,11.024317 10.9299703,0.5 23.8027778,0.5 C24.9594971,0.5 26.1061563,0.585109698 27.2363838,0.753525891 Z M3.5,24 C3.5,35.324846 12.592902,44.5 23.8027778,44.5 C28.3083661,44.5 32.5693004,43.0092788 36.0311018,40.3680687 C35.2662178,40.4556717 34.4926398,40.5 33.7131314,40.5 C22.4823249,40.5 13.3834596,31.3188287 13.3834596,20 C13.3834596,13.4198245 16.486903,7.42568759 21.4632546,3.63465291 C11.3546269,4.80589302 3.5,13.4744735 3.5,24 Z" />
                </g>
            </g>
        </g>
    </svg>
);
